import React, { useState, useEffect } from "react";
import { X, Search } from "lucide-react";

const AddItemModal = ({ isOpen, onClose, onAddItem }) => {
  const [allItems, setAllItems] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isOpen) return;

    setLoading(true);

    fetch(`https://smart-budget-ke77.onrender.com/api/products?search=${search}`) // IMPORTANT: your real route
      .then((res) => res.json())
      .then((data) => {
        setAllItems(data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.log("❌ Error fetching items:", err);
        setAllItems([]);
        setLoading(false);
      });
  }, [isOpen, search]);

  if (!isOpen) return null;

  const filtered = allItems.filter((item) => {
    const t = search.toLowerCase();
    return (
      item.name.toLowerCase().includes(t) ||
      (item.category && item.category.toLowerCase().includes(t))
    );
  });

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-6 z-50">
      <div className="bg-[#FFF7E6] w-full max-w-2xl rounded-2xl shadow-xl border border-[#F3D7B1] overflow-hidden">

        {/* HEADER */}
        <div className="flex justify-between items-center p-5 border-b">
          <h2 className="text-xl font-bold text-[#5A3E2B]">Add Item</h2>
          <button onClick={onClose}>
            <X size={28} className="text-[#5A3E2B] hover:text-black" />
          </button>
        </div>

        {/* SEARCH BAR */}
        <div className="p-4">
          <div className="flex items-center gap-3 px-4 py-3 bg-[#FAF7F2] border border-[#E8D1B7] rounded-xl">
            <Search className="text-gray-500" />
            <input
              className="flex-1 bg-transparent outline-none text-[#5A3E2B]"
              placeholder="Search items..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        {/* ITEM LIST */}
        <div className="max-h-[350px] overflow-y-auto px-4 pb-6">
          {loading ? (
            <p className="text-center text-gray-500 py-4">Loading items...</p>
          ) : filtered.length === 0 ? (
            <p className="text-center text-gray-400 py-4">No items found.</p>
          ) : (
            filtered.map((item) => (
              <div
                key={item.id || item.name}
                className="flex justify-between items-center p-4 mb-3 rounded-xl bg-white border border-[#F3D7B1]"
              >
                <div>
                  <p className="font-semibold text-[#5A3E2B]">{item.name}</p>
                  <p className="text-xs text-gray-600">{item.category}</p>
                  <p className="text-xs text-gray-500">{item.store}</p>
                </div>

                <div className="flex items-center gap-4">
                  <p className="font-bold text-[#FF8C42]">
                    RM {item.price?.toFixed(2)}
                  </p>

                  <button
                    onClick={() => {
                      console.log("Adding item:", item);
                      onAddItem(item);
                      onClose();
                    }}
                    className="w-9 h-9 rounded-full bg-[#38A3A5] text-white text-xl font-bold flex items-center justify-center hover:brightness-110"
                  >
                    +
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

      </div>
    </div>
  );
};

export default AddItemModal;
